import type { Environment } from './environment-constants';
import { LOCAL, DEVELOPMENT, STAGING, PRODUCTION } from './environment-constants';

type MicrosEnvironment = 'local' | 'ddev' | 'adev' | 'stg-east' | 'prod-east' | 'stg-fedm-east' | 'prod-fedm-east';

export const MICROS_ENV = String(process.env.MICROS_ENV) as MicrosEnvironment;

export const NODE_ENV = String(process.env.NODE_ENV);

export const ENVIRONMENT = process.env.ENVIRONMENT as Environment;

export const MICROS_PERIMETER = process.env.MICROS_PERIMETER;

// Determining the environment using the hostname
export const getEnvironment: () => Environment = () => {
  const hostName = window.location.hostname;
  if (hostName.includes('.dev.')) {
    return DEVELOPMENT as Environment;
  } else if (hostName.includes('.staging.') || hostName.includes('.stg.')) {
    return STAGING as Environment;
  } else if (
    hostName.includes('.prod.') ||
    hostName.includes('ppc.atlassian') ||
    hostName.includes('admin.atlassian')
  ) {
    return PRODUCTION as Environment;
  } else if (hostName.includes('localhost')) {
    return LOCAL as Environment;
  } else {
    return STAGING as Environment;
  }
};

export const getMicrosEnv = () => {
  return MICROS_ENV;
};

export const isLocalEnv = () => {
  return NODE_ENV === 'local';
};

// For unit test
export const getCurrentEnvironment = () => {
  return ENVIRONMENT;
};

export const getMicrosPerimeter = () => {
  return MICROS_PERIMETER;
};
